// check if we have a discount code currently applied
function welcomeDiscountApplied() {
    // should always be true if discount codes is present, if not, return null
    if (!Array.isArray(cart.discount_codes)) {
        return null;
    }

    // some code in the cart contains the welcome code and applicable is true (can be applied to items in cart)
    return cart.discount_codes.some(code => {
        return code.code.toUpperCase() === welcomeDiscount.code.toUpperCase() && code.applicable === true;
    });
}

// push the code onto the cart, return cart with new data
async function applyWelcomeDiscount() {
    try {
        cart = await updateCart({discount: welcomeDiscount.code})
        return cart;
    } catch (error) {
        console.error(`Could not apply discount ${welcomeDiscount.code}.`);
    }
}

/********************* Welcome Discount Popup *********************/

// sessionStorage key so the popup only toggles once, not on every pdp they browse
const WELCOME_POPUP_KEY = "welcomeDiscountShown";

// confirms the auto-applied discount once per session.
// popup comes from snippets/welcome-congrats.liquid, so every pdp shares one implementation
function initWelcomePopup() {
    const popup = document.querySelector('#welcomeCongrats');

    // nothing to do on pages that do not render the snippet, when the setting is blank, or once we
    // have already announced it this session
    if (!popup || !welcomeDiscount.code || sessionStorage.getItem(WELCOME_POPUP_KEY)) {
        return;
    }

    sessionStorage.setItem(WELCOME_POPUP_KEY, "1");

    // holds the auto close timer so a manual close can cancel it
    let congratsTimer = null;

    // close popup function
    function closeCongrats() {
        // drop the auto close timer, otherwise it fires again after a manual close
        clearTimeout(congratsTimer);

        popup.classList.remove('active');

        // wait for the transition to finish before actually closing
        setTimeout(() => {
            popup.close();
            document.querySelector('body').classList.remove('noScroll');
        }, 650);
    }

    // x icon click close
    popup.querySelector('#welcomeCongratsClose').addEventListener('click', closeCongrats);

    // outside click close
    popup.addEventListener('click', function (e) {
        if (e.target === this) {
            closeCongrats();
        }
    });

    // accessibility close
    popup.addEventListener('close', closeCongrats);

    // fill the copy before showing so it never paints empty
    popup.querySelector('#welcomeCongratsText').innerHTML = `Congrats! Your <strong>${welcomeDiscount.percent}% off welcome discount</strong> has been auto-applied.`;

    popup.showModal();
    popup.classList.add('active');

    // this is a confirmation, not a decision, so dismiss it for them after six seconds
    congratsTimer = setTimeout(closeCongrats, 6000);
}

initWelcomePopup();
